import React from "react";
import ProdutoModel from "../model/ProdutoModel";
import ProdutoItem from "./ProdutoItem";
import ConteudoModel from "../model/ConteudoModel";
import ConteudoItem from "./ConteudoItem";
import ReactDOM from "react-dom";

type ListaItensProps = {
  produtos?: ProdutoModel[]
  conteudos?: ConteudoModel[],
  parent?: React.Component,
  carregando: boolean,
  concluido: boolean,
};

class ListaItens extends React.Component<ListaItensProps, {}> {

  componentDidUpdate(): any {
    const el: any = ReactDOM.findDOMNode(this.refs.items);
    const items: any = el.getElementsByClassName("content");
    for(const item of items) {
      if (item.attributes["data-bg"]) {
        item.style.backgroundImage = `url(${ item.attributes["data-bg"].value })`;
      }
    }
  }

  render(): any {
    const { produtos, conteudos, carregando } = this.props;
    const parent: React.Component = this.props.parent ? this.props.parent : this;

    return (
      <div className="product-group">
        <div className="products nobg" ref="items">
          <div className="items list">
            { !carregando && produtos !== undefined && produtos.length > 0 && produtos.map((item: ProdutoModel) =>
            <ProdutoItem item={ item } key={ item.produtoId } parent={parent} ></ProdutoItem>
            )}
            { !carregando && produtos !== undefined && produtos.length === 0 &&
            <div>
              <p className="none title">Ops!</p>
              <p className="none">Não encontramos o que <br/> você está procurando</p>
            </div>
            }
            { !carregando && conteudos !== undefined && conteudos.length > 0 && conteudos.map((item: ConteudoModel) =>
            <ConteudoItem item={ item } parent={parent} key={ item.conteudoId }></ConteudoItem>
            )}
            { !carregando && conteudos !== undefined && conteudos.length === 0 &&
            <div>
              <p className="none title">Ops!</p>
              <p className="none">Não encontramos o que <br/> você está procurando</p>
            </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ListaItens;